"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _Wapp = require("wapplr-react/dist/common/Wapp");

var _context = _interopRequireDefault(require("../Configurator/context"));

var _withMaterial = require("configurator-studio-arkitekter-components/dist/common/components/Template/withMaterial");

var _materialStyle = _interopRequireDefault(require("./materialStyle"));

var _Gallery = _interopRequireDefault(require("../Gallery"));

var _excluded = ["layers", "dayPeriod"];

var style = require("./style_css.js")["default"];

var Image = /*#__PURE__*/_react["default"].memo(function (props) {
  var _props$src;

  return /*#__PURE__*/_react["default"].createElement("img", Object.assign({}, props, {
    style: (_props$src = props.src) !== null && _props$src !== void 0 && _props$src.match("/?night") ? {
      filter: "brightness(60%)"
    } : {}
  }));
}, function () {
  return true;
});

function Layers(props) {
  var context = (0, _react.useContext)(_Wapp.WappContext);
  var configuratorContext = (0, _react.useContext)(_context["default"]);
  var wapp = context.wapp;
  wapp.styles.use(style);
  var _props$layers = props.layers,
      layers = _props$layers === void 0 ? [] : _props$layers,
      dayPeriod = props.dayPeriod;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: style.layers
  }, layers.sort(function (a, b) {
    return typeof a.order == "number" && typeof b.order == "number" ? a.order - b.order : 0;
  }).filter(function (ig) {
    return configuratorContext.getDayPeriodImage(ig, dayPeriod);
  }).map(function (ig, i) {
    return i === 0 ? /*#__PURE__*/_react["default"].createElement("div", {
      key: i,
      className: style.imageContainer
    }, /*#__PURE__*/_react["default"].createElement(Image, {
      src: configuratorContext.getDayPeriodImage(ig, dayPeriod),
      className: style.image,
      alt: ig.alt || ig.description || "layers main image"
    })) : /*#__PURE__*/_react["default"].createElement("div", {
      key: i,
      className: style.layer,
      style: {
        backgroundImage: "url(" + configuratorContext.getDayPeriodImage(ig, dayPeriod) + ")"
      }
    });
  }));
}

function GalleryForCollectedImages(props) {
  var _props$layers2 = props.layers,
      layers = _props$layers2 === void 0 ? [] : _props$layers2,
      dayPeriod = props.dayPeriod,
      rest = (0, _objectWithoutProperties2["default"])(props, _excluded);
  var gallery = layers.reduce(function (r, layer) {
    layer.forEach(function (image, gi) {
      if (!r[gi]) {
        r[gi] = [];
      }

      r[gi].push(image);
    });
    return r;
  }, []);
  return /*#__PURE__*/_react["default"].createElement(_Gallery["default"], Object.assign({}, rest, {
    gallery: gallery,
    renderItemComponents: function renderItemComponents(_ref) {
      var gallery = _ref.gallery;
      return gallery.map(function (layers, i) {
        return /*#__PURE__*/_react["default"].createElement(Layers, {
          key: i,
          layers: layers,
          dayPeriod: dayPeriod
        });
      });
    }
  }));
}

var WappComponent = (0, _Wapp.withWapp)(GalleryForCollectedImages);
var StyledComponent = (0, _withMaterial.withMaterialStyles)(_materialStyle["default"], WappComponent);
var _default = StyledComponent;
exports["default"] = _default;